import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getDecisionQuestions(axiosPrivate, decisionId) {
	return axiosPrivate
		.get(`${apiURL}/decision/${decisionId}/questions.json`)
		.then((res) => {
			if (res.status >= 200 && res.status < 300) return res.data;
		})
		.catch((err) => {
			console.error("Error loading questions", err);
			return err.response;
		});
}

export async function updateDecisionQuestions(axiosPrivate, cb, decisionId, questionsArray) {
	return axiosPrivate
		.put(`${apiURL}/decision/${decisionId}/questions.json`, {
			questions: questionsArray, 
		})
		.then((res) => {
			if (res.status >= 200 && res.status < 300) {
				toast.success("Questions updated");
				return res.data;
			} else {
				toast.error("Could not update questions. Please try again.");
			}
		})
		.catch((err) => {
			toast.error("Could not update questions. Please try again.");
			return err.response;
		});
}
